module.exports = __webpack_public_path__ + "static/media/3DPPA11.f38e361a.jpg";